import { Heading } from '@rabbit/elements/shared-components';

export interface BreadCrumbsProps {
  title: string;
  children?: React.ReactNode;
  className?: string;
}

export function BreadCrumbs({ title, className, children }: BreadCrumbsProps) {
  return (
    <div className={`break-words border-b py-4 pl-8 ${className}`}>
      <Heading kind={'h2'}>{title}</Heading>
      {children}
    </div>
  );
}

export default BreadCrumbs;
